var _defs, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path6, _path7, _path8, _polygon14, _polygon15, _polygon16, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse, _ellipse2, _rect, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.95 271.01",
    width: 406,
    height: 306,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 31.34,
    y1: -170.33,
    x2: 79.5,
    y2: -280.63,
    gradientTransform: "matrix(1, 0.03, 0.03, -1, 52.05, -6.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1051.04,
    y1: -786.07,
    x2: -1131.28,
    y2: -854.43,
    gradientTransform: "matrix(0.84, 0.54, 0.54, -0.84, 1456.68, 100.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 465.98,
    y1: -840.65,
    x2: 586.83,
    y2: -728.98,
    gradientTransform: "matrix(0.84, 0.54, 0.54, -0.84, 112.96, -750.67)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 280.18,
    y1: 144.87,
    x2: 96.08,
    y2: 47.13,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 287.85,
    y1: 130.43,
    x2: 103.75,
    y2: 32.69,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 288.64,
    y1: 128.94,
    x2: 104.54,
    y2: 31.21,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 207.78,
    y1: 153.18,
    x2: 234.3,
    y2: 81.45,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 186.6,
    y1: 140.88,
    x2: 256.81,
    y2: 37.34,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 194.48,
    y1: 127.7,
    x2: 219.05,
    y2: 56.67,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 360.87,
    y1: 236.02,
    x2: -34.61,
    y2: 94.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 203.88,
    y1: 344.47,
    x2: 218.24,
    y2: 46.3,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 182.13,
    y1: 331.12,
    x2: 278.98,
    y2: 28.16,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 188.25,
    y1: 278.17,
    x2: 257.51,
    y2: 37.44,
    gradientTransform: "matrix(1, 0, 0, -1, -28.56, 321.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 133.84,
    y1: 258.16,
    x2: 326.91,
    y2: -26.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 139.42,
    y1: 234.62,
    x2: 171.84,
    y2: 204.65,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 151.61,
    y1: 230.77,
    x2: 162.94,
    y2: 225.14,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 142.35,
    y1: 215.83,
    x2: 148.99,
    y2: 230.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 167.33,
    y1: 286.01,
    x2: 174.51,
    y2: 270.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 352)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -796.95,
    y1: 291.51,
    x2: -751.43,
    y2: 272.12,
    gradientTransform: "matrix(-0.08, -1, 1, -0.08, -206.76, -702.88)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M127.81,56.34c-6.11,6.31-11.17,13.54-16.56,20.48-20.17,26-45.09,48.4-62.76,76.19S21.24,217,35.36,246.7c9.52,20.07,28.52,34.3,48.89,43.14a135.56,135.56,0,0,0,55.31,11.54c39.81-.47,76.72-19.91,115.65-28.27,17.26-3.71,35-5.25,52.06-9.74,12.1-3.18,23.94-7.91,34-15.34,27.81-20.51,37.65-59.69,29.44-93.26s-31.78-61.71-59.39-82.5C264.49,37,175.65,6.93,127.81,56.34Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "112.34 197.9 76.31 196.74 80.78 222.44 106.31 223.27 112.34 197.9",
    fill: "#008ffb"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.34 197.9 76.31 196.74 80.78 222.44 106.31 223.27 112.34 197.9",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.86,165.08a12.43,12.43,0,0,0-1.28,5.81c-.45,9.11-.38,18.4,2.35,27.09,4,12.78,13.32,23.09,22.38,33-.68-1.09,1.33-6.87,1.6-8.25.53-2.7,1.13-5.39,1.69-8.08.9-4.26,0-8.74-1.06-12.93A61.81,61.81,0,0,0,114.31,176,58.41,58.41,0,0,0,101.86,165.08Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.86,165.08a12.43,12.43,0,0,0-1.28,5.81c-.45,9.11-.38,18.4,2.35,27.09,4,12.78,13.32,23.09,22.38,33-.68-1.09,1.33-6.87,1.6-8.25.53-2.7,1.13-5.39,1.69-8.08.9-4.26,0-8.74-1.06-12.93A61.81,61.81,0,0,0,114.31,176,58.41,58.41,0,0,0,101.86,165.08Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.22,195.9c3.06-6.8,6.15-13.69,7.3-21.06s.13-15.37-4.38-21.31q-8.73,13.23-17.48,26.45c-3.36,5.09-6.78,10.29-8.43,16.17-2.89,10.31-.32,26.17,6.55,34.53,3.92-3.35,5.75-11,7.87-15.73Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.22,195.9c3.06-6.8,6.15-13.69,7.3-21.06s.13-15.37-4.38-21.31q-8.73,13.23-17.48,26.45c-3.36,5.09-6.78,10.29-8.43,16.17-2.89,10.31-.32,26.17,6.55,34.53,3.92-3.35,5.75-11,7.87-15.73Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.87,218.26l38.64,1.25a5.85,5.85,0,0,1,5.66,6h0a5.85,5.85,0,0,1-6,5.65L103.49,230a5.86,5.86,0,0,1-5.66-6h0A5.86,5.86,0,0,1,103.87,218.26Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.1 186.49 186.56 215.78 225.28 222.18 212.82 187.84 174.1 186.49",
    fill: "#008ffb"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.1 186.49 186.56 215.78 225.28 222.18 212.82 187.84 174.1 186.49",
    fill: "url(#linear-gradient-4)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.56 215.78 161.64 222.18 212.65 236.83 225.28 222.18 186.56 215.78",
    fill: "url(#linear-gradient-5)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.56 215.78 161.64 222.18 206.59 243.86 225.28 222.18 186.56 215.78",
    fill: "#008ffb"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.56 215.78 161.64 222.18 206.59 243.86 225.28 222.18 186.56 215.78",
    fill: "url(#linear-gradient-6)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "166.77 186.49 179.23 215.78 217.96 222.18 205.5 187.84 166.77 186.49",
    fill: "#008ffb"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "176.12 208.47 210.27 200.98 205.5 187.84 166.77 186.49 176.12 208.47",
    fill: "url(#linear-gradient-7)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "179.23 215.78 154.32 222.18 205.33 236.83 217.96 222.18 179.23 215.78",
    fill: "#008ffb"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "179.23 215.78 154.32 222.18 205.33 236.83 217.96 222.18 179.23 215.78",
    fill: "url(#linear-gradient-8)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.33 236.83 206.59 243.86 153.05 227.74 154.32 222.18 205.33 236.83",
    fill: "#008ffb"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.33 236.83 206.59 243.86 153.05 227.74 154.32 222.18 205.33 236.83",
    fill: "url(#linear-gradient-9)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.84,94.41V225.94a5.58,5.58,0,0,1-5.6,5.58l-.6,0L142.21,215.06a5.58,5.58,0,0,1-5-5.55V109.43a5.58,5.58,0,0,1,5-5.55l147.43-15a5.59,5.59,0,0,1,6.17,4.93Q295.84,94.11,295.84,94.41Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.84,94.41V225.94a5.58,5.58,0,0,1-5.6,5.58l-.6,0L142.21,215.06a5.58,5.58,0,0,1-5-5.55V109.43a5.58,5.58,0,0,1,5-5.55l147.43-15a5.59,5.59,0,0,1,6.17,4.93Q295.84,94.11,295.84,94.41Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-10)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M292.14,94.41V225.94a5.58,5.58,0,0,1-5.6,5.58l-.6,0L138.51,215.06a5.58,5.58,0,0,1-5-5.55V109.43a5.58,5.58,0,0,1,5-5.55L286,88.86a5.58,5.58,0,0,1,6.11,5A5.25,5.25,0,0,1,292.14,94.41Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.34 170.66 112.34 79.04 251.97 67.7 251.97 178.28 112.34 170.66",
    fill: "url(#linear-gradient-11)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.56 131.33 149.58 131.33 149.58 91.17 233.56 87.43 233.56 131.33",
    fill: "url(#linear-gradient-12)"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.56 177.49 149.58 173.03 149.58 135.51 233.56 135.51 233.56 177.49",
    fill: "url(#linear-gradient-13)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.14,209.45v16.49a5.58,5.58,0,0,1-5.6,5.58l-.6,0L138.51,215.06a5.58,5.58,0,0,1-5-5.55V201Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-14)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.79,125.74c0,1.28-2.06,2.49-3.07,2.79a6.76,6.76,0,0,0-1.23.39,1.17,1.17,0,0,0-.64,1.05c.05.37.35.67.43,1a2,2,0,0,1-.11,1c-.39,1.23-1.92,2-2.29,3.25-2.12-.22-3.07,0-5.17-.39L145,133.7l2.64-4.94a10.26,10.26,0,0,1,1.25-1.95,8.54,8.54,0,0,1,1.94-1.55,49.12,49.12,0,0,1,5.72-3.19C156.25,122.19,158.79,125.41,158.79,125.74Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-15)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.76,73.27l-.21.08a30.65,30.65,0,0,1-3.52.87l-2.71.64a6,6,0,0,1-2.54.42,3.9,3.9,0,0,1,1.72-1.91c.58-.28,1.25-.37,1.82-.67a2.82,2.82,0,0,0,1.3-3.34,2.1,2.1,0,0,0-.66-.94,2.41,2.41,0,0,0-2.88.39,23,23,0,0,0-2,2.41,42.93,42.93,0,0,1-3.73,3c-1.2,1.07-2.15,2.7-1.69,4.24s2.43,1.36,3.8,1.36a23.65,23.65,0,0,0,5.1-.63c1.65-.36,3.28-.82,4.92-1.25a18.23,18.23,0,0,1,2.4-.58,5,5,0,0,0,1.59-.2,3.16,3.16,0,0,0,1.15-1,4.11,4.11,0,0,0,1-2.28c.06-1.18-.74-2.33-2-2A25.15,25.15,0,0,0,163.76,73.27Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#f9c6d6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.56,119.93a2.42,2.42,0,0,1,0,2.13,1.77,1.77,0,0,1-.77.55,2.11,2.11,0,0,1-2.21-.23,2.92,2.92,0,0,1-.66-1.27,30.79,30.79,0,0,1-1.19-5.28,1,1,0,0,1,0-.49.84.84,0,0,1,.42-.39c.93-.51,2.4-.91,2.93.21A37.61,37.61,0,0,1,157.56,119.93Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#f9c6d6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154.73,120.75a1.19,1.19,0,0,0-.59.06.92.92,0,0,0-.33.29l-2,2.32c-.39.45-.81,1.07-.53,1.59a1.18,1.18,0,0,0,.88.53A5.09,5.09,0,0,0,155,125c.63-.28,1.25-.58,1.85-.91a3,3,0,0,0,1.15-.91c.46-.72.6-2.45-.22-3-.42-.27-.79-.08-1.18.11A4.07,4.07,0,0,1,154.73,120.75Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.29,127.83a.86.86,0,0,0,0,.39.72.72,0,0,0,.3.3,2.47,2.47,0,0,0,1.31.44,1.5,1.5,0,0,0,1.23-.56,2.49,2.49,0,0,0,.38-1.15,14.34,14.34,0,0,0,.26-2.69.5.5,0,0,0-.12-.35.5.5,0,0,0-.23-.09c-.74-.16-2.19-.55-2.56.36A10.62,10.62,0,0,0,146.29,127.83Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#f9c6d6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.19,127.74a6.73,6.73,0,0,0-1.84.35,2.36,2.36,0,0,0-1.35,1.26,1.39,1.39,0,0,0,0,.9,2,2,0,0,0,1,1,12.62,12.62,0,0,0,6.84,1.49,2.33,2.33,0,0,0,1.65-.61,2.72,2.72,0,0,0,.44-1.69l.08-2.81a3.56,3.56,0,0,0-1.52.44c-.87.3-1.21-.42-1.94-.59A11.49,11.49,0,0,0,143.19,127.74Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.73,120.75a1.19,1.19,0,0,0-.59.06.92.92,0,0,0-.33.29l-2,2.32c-.39.45-.81,1.07-.53,1.59a1.18,1.18,0,0,0,.88.53A5.09,5.09,0,0,0,155,125c.63-.28,1.25-.58,1.85-.91a3,3,0,0,0,1.15-.91c.46-.72.6-2.45-.22-3-.42-.27-.79-.08-1.18.11A4.07,4.07,0,0,1,154.73,120.75Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-16)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.19,127.74a6.73,6.73,0,0,0-1.84.35,2.36,2.36,0,0,0-1.35,1.26,1.39,1.39,0,0,0,0,.9,2,2,0,0,0,1,1,12.62,12.62,0,0,0,6.84,1.49,2.33,2.33,0,0,0,1.65-.61,2.72,2.72,0,0,0,.44-1.69l.08-2.81a3.56,3.56,0,0,0-1.52.44c-.87.3-1.21-.42-1.94-.59A11.49,11.49,0,0,0,143.19,127.74Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-17)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.7,96.7a2.5,2.5,0,0,0-2.23,2.75c0,.11,0,.21.06.32a46.22,46.22,0,0,0,3.12,16.6,1.46,1.46,0,0,0,.7.94,1.38,1.38,0,0,0,.94,0,36,36,0,0,0,3.63-1.22l-1.61-10.79a1.57,1.57,0,0,1,.05-.91,1.53,1.53,0,0,1,.48-.5,43.59,43.59,0,0,1,5.78-3.6c1.61-.83,3.45-1.78,3.89-3.55A2,2,0,0,0,165.2,95a2.94,2.94,0,0,0-.89-.59,7.31,7.31,0,0,0-3.64-1.1c-1,.11-1.36.68-2.18,1.11C156.2,95.54,153.17,96,150.7,96.7Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#282328"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.75,84.89a.61.61,0,0,0-.14-.29.52.52,0,0,0-.34-.09,37.48,37.48,0,0,0-12.42,1.32,13.73,13.73,0,0,0,1.44,3.11c1.62,2.84,3.24,5.69,4.89,8.52a2.7,2.7,0,0,0,3.36,1.82l.23-.08L163,97.94c1-.2-1-5.35-1.36-6.3C160.86,89.44,160.34,87.15,159.75,84.89Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M168.09,96.49a23.28,23.28,0,0,1-2.9-1.37c-3.54-2-.64-3,.54-5.35.84-1.7.5-3.73.06-5.57-.77-3.23-1.8-6.58-1-9.81a3.74,3.74,0,0,1,.6-1.46,4.26,4.26,0,0,1,.74-.73,7.86,7.86,0,0,1,2.54-1.5,7.25,7.25,0,0,1,5.45.69c6.85,3.49,6.81,14.63,6.16,21.18a8.09,8.09,0,0,1-1.3,4.3c-1.35,1.78-2.61,1.14-4.32.84C172.35,97.32,170.29,97.35,168.09,96.49Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.08,75.33a3.38,3.38,0,0,1-2.38,1.25.62.62,0,0,1-.42-.1.71.71,0,0,1-.21-.5c0-.37-.09-.85-.13-1.32s-.12-1.06-.17-1.47a5.78,5.78,0,0,0-1.18-3,3.27,3.27,0,0,0-.47-.51c-1.14-1,3.51-.62,4.12-2,.71.91.65,2.2,1,3.32a14,14,0,0,1,.52,1.67A3.35,3.35,0,0,1,172.08,75.33Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#f9c6d6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169,74.87l-.06-.21c-.06-.53-.12-1.06-.17-1.47a5.78,5.78,0,0,0-1.18-3v-.11s3.68-2.42,4.08.41S169,74.87,169,74.87Z",
    transform: "translate(-28.56 -30.37)",
    fill: "url(#linear-gradient-18)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M165.13,68.54a3,3,0,0,0,.31,1.71,2.48,2.48,0,0,0,.55.57,4.36,4.36,0,0,0,5.13-.26,6.56,6.56,0,0,0,2.28-4.9,3.74,3.74,0,0,0-.76-2.72,3,3,0,0,0-2.77-.77,7,7,0,0,0-3.51,2C165.43,65.21,165.2,67.21,165.13,68.54Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#f9c6d6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.85,104.23a11.48,11.48,0,0,0-1.77,3.24,65.4,65.4,0,0,0-4.48,17.78,22.65,22.65,0,0,0,5.7,0,54.82,54.82,0,0,1,2-12.78,8.2,8.2,0,0,1,1-2.52,8.85,8.85,0,0,1,3.56-2.63,51.83,51.83,0,0,1,9.56-3.63c1.39-.39,2.79-.74,4.16-1.21a10.19,10.19,0,0,0,3.24-1.67c1.71-1.43,3-4.56.74-6.1a7.62,7.62,0,0,0-3.55-.94l-3.82-.36a2.2,2.2,0,0,0-2,.57c-2.84,2.19-5.75,4.14-8.73,6.13C155.58,101.35,153.33,102.49,151.85,104.23Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#473f47"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.4,78.21a1.68,1.68,0,0,0,.08.62A65.27,65.27,0,0,1,178.4,88c-.07,1.88-.32,5.48-2.29,6.44-3.7,1.81-10.81,1.11-10.81,1.11a6.27,6.27,0,0,0-2.48.1c-.45.14-.85.38-1.29.55a9,9,0,0,1-4.93,0,2.11,2.11,0,0,1-.81-.28,1.5,1.5,0,0,1-.13-2.07,3.68,3.68,0,0,1,2-1.1,11.43,11.43,0,0,1,6.4-.25c.28.08.55.17.83.23a5.6,5.6,0,0,0,1,.06h2.51c2.89,0,5.61,0,6-3.4a19.61,19.61,0,0,0,.1-3.83c-.17-2.31-.77-4.59-.64-6.9a4.53,4.53,0,0,1,.52-2.1,2.08,2.08,0,0,1,1.73-1.11,2.18,2.18,0,0,1,1.79,1.21A5,5,0,0,1,178.4,78.21Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#f9c6d6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.64,67a9,9,0,0,1,.16,2.13c.49-.44.46-1.53,1.11-1.5.39,0,.57.56.39.91a1.47,1.47,0,0,1-1,.64c-.11,1.5,1.08,2.52,2.06,3.43a7.93,7.93,0,0,1,2.18,3.87,22,22,0,0,1,.42,5.73c.53-.42,1.28-.2,1.95-.13a4.26,4.26,0,0,0,4.35-3.31A4.84,4.84,0,0,0,180,73.7a3.78,3.78,0,0,1-1.47-1.06c-.44-.7-.18-1.63-.15-2.47a4.15,4.15,0,0,0-3.12-4,5.92,5.92,0,0,0,.68-2.12,3.65,3.65,0,0,0-1.16-2.67,8.48,8.48,0,0,0-2.5-1.58,4,4,0,0,0-2.73-.47,3.62,3.62,0,0,0-2.1,2.44,1.33,1.33,0,0,0-1.54.31,2.15,2.15,0,0,0-.53,1.57,3.17,3.17,0,0,0,.23,1.09c.35-.42.77-.83,1.19-.53s.68.92,1.06,1.26a7.41,7.41,0,0,0,1.37.91A8,8,0,0,1,170.64,67Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#f86938"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M161.48,65.9l-.35,1.94a1.11,1.11,0,0,1-1,1c-1.89-.33-6.52-1-9.82-.12a35.21,35.21,0,0,0-5.27,1.8c-.68.3-1.35-.46-1.24-1.38L145,58.77c.11-.91.9-1.36,1.48-.83,2.38,2.15,7.9,6.45,14.07,6.43C161.16,64.37,161.62,65.11,161.48,65.9Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#008ffb"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.98,
    cy: 64.02,
    rx: 6.52,
    ry: 3.11,
    transform: "translate(41.17 173.13) rotate(-85.48)",
    fill: "#008ffb"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.98,
    cy: 64.02,
    rx: 6.52,
    ry: 3.11,
    transform: "translate(41.17 173.13) rotate(-85.48)",
    fill: "url(#linear-gradient-19)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155.18,
    y: 72.45,
    width: 2.82,
    height: 2.82,
    rx: 0.87,
    transform: "translate(8.51 168.76) rotate(-71.6)",
    fill: "#008ffb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309,168.81H227.18a6.27,6.27,0,0,1-6.26-6.26V132.41a6.26,6.26,0,0,1,6-6.25l81.8-3.79a6.24,6.24,0,0,1,6.54,5.94c0,.11,0,.21,0,.31v33.93a6.26,6.26,0,0,1-6.26,6.26Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#fff",
    opacity: 0.89,
    style: {
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M257.53,114.36,199,117.29a4.21,4.21,0,0,1-4.47-3.93,2.81,2.81,0,0,1,0-.29V91.7a4.74,4.74,0,0,1,4.28-4.65l58.56-5.62a4.23,4.23,0,0,1,4.69,4.2V109.7A4.72,4.72,0,0,1,257.53,114.36Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M164.7,177l-42.35-2a4.6,4.6,0,0,1-4.38-4.6V153.08a4.59,4.59,0,0,1,4.54-4.59l42.35-.47a4.6,4.6,0,0,1,4.65,4.55v19.87a4.59,4.59,0,0,1-4.64,4.56Z",
    transform: "translate(-28.56 -30.37)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.11df3de4b1b067f26ee2644742b8af7b.svg";
export { ForwardRef as ReactComponent };